import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { StaffPost } from "../../../../types/types";
import { Button } from "../../../../ui/Button";
import { Input } from "../../../../ui/Input/Input";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { NavLink } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";

const AddPosition = () => {
  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/posts`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
        },
      },
    });
    reset();
  };

  const posts = useAppStore((store) => store.posts)!;
  const setPosts = useAppStore((store) => store.setPosts);

  const addPost = (itemSaveResponse: { data: unknown }) => {
    const newPostData = itemSaveResponse.data as unknown as StaffPost;
    setPosts([...posts, newPostData]);
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    addPost(itemSaveResponse);
  }, [itemSaveResponse]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/positions"} className="text-sm flex gap-2 items-center text-muted-foreground hover:text-primary"><TbArrowLeft />{t("positions")}</NavLink>
            <span className="text-2xl font-semibold">{t('adding_post')}</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="px-6">
          <div className="flex flex-col w-full h-full gap-2">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={t("post_name")} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddPosition;
